import {
  signIn,
  getCurrentUser,
  signOut,
  confirmResetPassword,
  fetchAuthSession,
  setUpTOTP,
  verifyTOTPSetup,
  confirmSignIn,
  updateMFAPreference,
  fetchMFAPreference,
  updatePassword,
  rememberDevice as rememberDeviceAuth,
} from "aws-amplify/auth";

export const cognitoLogout = () => {
  return signOut();
};

export const cognitoLogin = async (username, password) => {
  await cognitoLogout().catch((err) => {
    console.error("sign out before login err", err);
  });
  return signIn({
    username, // registerInfo.email,
    password, // registerInfo.password,
  });
};

export const currentAuthenticatedUser = () => {
  return getCurrentUser();
};

export const getUserMFASetting = async () => {
  const mfaSetting = await fetchMFAPreference();
  return mfaSetting.preferred;
};

export const generate2FASecret = async () => {
  const cognitoUser = await getCurrentUser();
  if (!cognitoUser) throw new Error("Cognito user not found");
  return setUpTOTP();
};

export const verify2FASecret = async (token) => {
  const cognitoUser = await getCurrentUser();
  if (!cognitoUser) throw new Error("Cognito user not found");
  const friendlyName =
    typeof window !== "undefined" ? window.navigator?.userAgent || "" : "";
  return verifyTOTPSetup({
    code: token,
    options: { friendlyDeviceName: friendlyName },
  });
};

export const setUserMFASetting = async (enabled) => {
  const cognitoUser = await getCurrentUser();
  if (!cognitoUser) throw new Error("Cognito user not found");
  return updateMFAPreference({
    totp: enabled ? "PREFERRED" : "DISABLED",
  });
};

export const confirmMFASignin = async (token) => {
  return confirmSignIn({ challengeResponse: token });
};

export const isAuthenticatedUser = async () => {
  try {
    await currentAuthenticatedUser();
    return true;
  } catch {
    return false;
  }
};

export const cognitoChangePassword = (oldPassword, newPassword) => {
  return updatePassword({ oldPassword, newPassword });
};

// * deprecated, we used the new flow to maintain the email template ourselves
export const cognitoForgotPasswordSubmit = (email, otp, newPassword) => {
  return confirmResetPassword({
    username: email,
    confirmationCode: otp,
    newPassword,
  });
};

export const currentSession = () => {
  return fetchAuthSession();
};

export const rememberDevice = () => {
  return rememberDeviceAuth();
};
